.search-box-container {
  display: flex;
  border: 1px solid var(--field-border);
}

.search-box {
  border: 0;
  width: 152px;
  height: 29px;
}

.search-button {
  display: flex;
  background-color: white;
  border-left: 0;
  padding-left: 4px;
  padding-right: 4px;
  cursor: pointer;
}

.search-button svg {
  width: 1rem;
}
